// extracted by mini-css-extract-plugin
export var conversationListItem = "_ym-2";
export var fullBleedList = "_ym-3";
export var messageText = "_ym-1";
export var previewText = "_ym-0";